export { default as Disclaimer } from './Disclaimer';
